// extracted by mini-css-extract-plugin
export default {"active":"MultipleFacilityBadge_active__XLcbe","inactive":"MultipleFacilityBadge_inactive__TvP5J","swiper":"MultipleFacilityBadge_swiper__zsjpM"};